import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6 12.75h2.25v1.5H6zm3.75 1.5H12v-1.5H9.75zm-3.75 3h2.25v-1.5H6zm3.75 0H12v-1.5H9.75zM6 8.25h2.25v-1.5H6zm3.75 0H12v-1.5H9.75zm-3.75 3h2.25v-1.5H6zm3.75 0H12v-1.5H9.75zM21 9v12H3V5.25A2.25 2.25 0 0 1 5.25 3h7.5A2.25 2.25 0 0 1 15 5.25v1.5h3.75A2.25 2.25 0 0 1 21 9m-7.5-3.75a.75.75 0 0 0-.75-.75h-7.5a.75.75 0 0 0-.75.75V19.5h9zm6 3.75a.75.75 0 0 0-.75-.75H15V19.5h4.5zm-3 5.25H18v-1.5h-1.5zm0 3H18v-1.5h-1.5zm0-6H18v-1.5h-1.5z"
    }, null, -1)
  ]))]))
}
export default { render: render }